<template>
	<div class="solutions">
		<div class="wrap">
        <div class="page-title">
					<p>Metals In Aqueous Solutions</p>

					<router-link to="/" class="btn hollow">Back To Home</router-link>
				</div>

				<div class="beaker-row">
					<div class="beaker-box" v-for="solution of solutionsArr" :key="solution.id">
						<Dunk
							:startBeakerImg="solution.startBeakerImg"
							:startMetalImg="startMetalImg"
							:reactions="solution.reactions"
							:formula="solution.formula"
							:animate="animate"
							:showEnd="showEnd"
							:lower="lower"
							:slowTrans="slowTrans"
						/>
						<transition name="fade">
							<MolecularModal
								v-if="showMolecularBtn"
								:metal="startMetalImg"
								:formula="solution.formula"
								:endMetal="solution.reactions[startMetalImg].endMetalImg"
								:charge="solution.charge" />
						</transition>
					</div>
				</div>

					<div class="instructions" v-if="showInstructions" :key="1">
						<h3>These beakers contain aqueous solutions, labeled above.</h3>
						
					</div>
					<div class="choose-a-metal" v-if="showChooseMetal" :key="2">
						<h3 v-if="showAnimateBtn">Pick a metal and test its reaction in the solutions.</h3>
						<h3 v-if="redoConfirm">Are your sure you want to repeat this experiment?</h3>
						<h3 v-if="showRemoveBtn">Now you can remove the metal. Record your observations.</h3>
						<div class="metal-btn-row">

							<button 
							class="metal-btn" 
							:class="{'active': startMetalImg === 'magnesium'}" 
							@click="startMetalImg = 'magnesium'; showEnd = false; redoConfirm=false; showAnimateBtn=true" 
							:disabled="disableMetalBtns"
							v-if="metalsArr.includes('magnesium')">
								Magnesium (Mg)
							</button>


							<button 
							class="metal-btn" 
							:class="{'active': startMetalImg === 'iron'}" 
							@click="startMetalImg = 'iron'; showEnd = false; redoConfirm=false; showAnimateBtn=true" 
							:disabled="disableMetalBtns"
							v-if="metalsArr.includes('iron')">
								Iron (Fe)
							</button>
							

							<button 
							class="metal-btn" 
							:class="{'active': startMetalImg === 'tin'}" 
							@click="startMetalImg = 'tin'; showEnd = false; redoConfirm=false; showAnimateBtn=true" 
							:disabled="disableMetalBtns"
							v-if="metalsArr.includes('tin')">
								Tin (Sn)
							</button>

							<button 
							class="metal-btn" 
							:class="{'active': startMetalImg === 'zinc'}" 
							@click="startMetalImg = 'zinc'; showEnd = false; redoConfirm=false; showAnimateBtn=true" 
							:disabled="disableMetalBtns"
							v-if="metalsArr.includes('zinc')">
								Zinc (Zn)
							</button>

							<button 
							class="metal-btn" 
							:class="{'active': startMetalImg === 'copper'}" 
							@click="startMetalImg = 'copper'; showEnd = false; redoConfirm=false; showAnimateBtn=true" 
							:disabled="disableMetalBtns"
							v-if="metalsArr.includes('copper')">
								Copper (Cu)
							</button>

							<button 
							class="metal-btn" 
							:class="{'active': startMetalImg === 'lead'}" 
							@click="startMetalImg = 'lead'; showEnd = false; redoConfirm=false; showAnimateBtn=true" 
							:disabled="disableMetalBtns"
							v-if="metalsArr.includes('lead')">
								Lead (Pb)
							</button>

							<button 
							class="metal-btn" 
							:class="{'active': startMetalImg === 'nickel'}" 
							@click="startMetalImg = 'nickel'; showEnd = false; redoConfirm=false; showAnimateBtn=true" 
							:disabled="disableMetalBtns"
							v-if="metalsArr.includes('nickel')">
								Nickel (Ni)
							</button>

							<button 
							class="metal-btn" 
							:class="{'active': startMetalImg === 'silver'}" 
							@click="startMetalImg = 'silver'; showEnd = false; redoConfirm=false; showAnimateBtn=true" 
							:disabled="disableMetalBtns"
							v-if="metalsArr.includes('silver')">
								Silver (Ag)
							</button>

						</div>
					</div>

				<div class="buttons">
						<span>
							<button class="btn" @click="showInstructions = false; showChooseMetal = true; showAnimateBtn = true" v-if="showInstructions" :key="1">Continue</button>
							<button class="btn" @click="beginAnimate" v-if="showAnimateBtn" :key="2" :disabled="!startMetalImg">Continue</button>
							<button class="btn" @click="removeMetal" v-if="showRemoveBtn" :key="3" :disabled="!startMetalImg">Remove</button>
							<button class="btn" @click="redoConfirmed" v-if="redoConfirm" :key="4">Yes, Repeat Experiment</button>
						</span>
				</div>

		</div>
	</div>
</template>


<script>
import { mapGetters } from 'vuex'
import Dunk from '../components/Dunk'
import MolecularModal from '@/components/MolecularModal'

export default {
	name:"Solutions",
	components:{
		Dunk,
		MolecularModal
	},
	data() {
		return {
			solutionsArr: [],
			metalsArr: [],
			animate: false,
			showInstructions: true,
			redoConfirm: false,
			confirmedRedo: false,
			showChooseMetal: false,
			showAnimateBtn: false,
			showRemoveBtn: false,
			disableMetalBtns: false,
			startMetalImg: false,
			alreadyDone: [],
			showEnd: false,
			lower: false,
			showMolecularBtn: false,
			slowTrans: false,
		}
	},
	computed: {
    ...mapGetters(['getPage'])
  },
	mounted() {
		let id = parseInt(this.$route.params.id);
		let page = this.getPage(id)
		this.solutionsArr = page.solutions
		this.metalsArr = page.metals
	},
	methods: {
		beginAnimate(){

			if(this.alreadyDone.includes(this.startMetalImg) && !this.confirmedRedo){
				this.redoConfirm = true
				this.showAnimateBtn = false
				this.showEnd = false
				return
			} 
			this.slowTrans = true
			this.disableMetalBtns = true
			if(this.confirmedRedo) this.confirmedRedo = false
			this.animate = true
			this.alreadyDone.push(this.startMetalImg)

			this.lower = true;
			this.showMolecularBtn = true

			setTimeout(() => {
				this.showEnd = true
				this.showAnimateBtn = false
				this.showRemoveBtn = true
				this.redoConfirm = false
			}, 1000);
		
		},
		removeMetal(){
			this.showAnimateBtn = true
			this.showRemoveBtn = false
			this.lower = false
			this.disableMetalBtns = false

			setTimeout(() => {
				this.showMolecularBtn = false
				this.slowTrans = false
			}, 500);
		},
		redoConfirmed(){
			this.confirmedRedo = true
			this.showEnd = false
			setTimeout(() => {
				this.beginAnimate();
			}, 300);
			
		}
	},
}
</script>


<style lang="scss">
	.beaker-row{
		display: grid;
		grid-template-columns: 1fr 1fr;
		grid-gap: 15px;

		@media screen and (min-width: 800px) {
			grid-template-columns: 1fr 1fr 1fr 1fr;
		}

		.beaker-box{
			overflow: hidden;
			box-shadow: $shadow;
			position: relative;
			padding-top: 3em;

			@media screen and (min-width: 500px) {
				padding-top: 5em;
			}

			@media screen and (min-width: 800px) {
				box-shadow: none;
				overflow: visible;
				padding-top: 0px;
			}
		}
	}


	.instructions, .choose-a-metal{
		text-align: center;
		h3{
			font-size: 26px;
			font-weight: 400;
			color: $grey;
			margin-bottom: 0;

			@media screen and (min-width: 800px) {
				font-size: 36px;
			}
		}

		p{
			font-weight: 400;
			margin-top: 10px;
			font-size: 28px;
			color: $grey;
		}
	}

	.buttons{
		padding: 1rem;
		position: sticky;
		bottom: 0px;
		background: rgba(#fff, 0.5);
		backdrop-filter: blur(20px);
		span{
			display: flex;
			justify-content: center;
		}

		@media screen and (min-width: 800px) {
			position: static;
			backdrop-filter: none;
		}
	}

	.metal-btn-row{
		justify-content: space-around;
		padding: 3rem 1rem;
		padding-bottom: 1em;

		@media screen and (min-width: 800px) {
			display: flex;
			padding-bottom: 0px;
		}
	}

	.metal-btn{
		width: 100%;
		margin: .5em 0px;
		background: none;
		border: solid 3px $bordergrey;
		color: $grey;
		font-weight: 400;
		font-size: 1.3rem;
		padding: .7rem 1.3rem;
		letter-spacing: .1rem;
		border-radius: 100px;
		transition: all 250ms;

		@media screen and (min-width: 800px) {
			flex: 0 1 20%;
		}

		&.active{
			background: $bordergrey;

			&:hover{
				background: $bordergrey;
				border-color: $bordergrey;
			}
		}

		&:hover{
			background: none;
			border-color: $blue;
			color: $grey;
		}
	}


	.fade-enter-active, .fade-leave-active {
		transition: all 500ms;
	}
	.fade-enter, .fade-leave-to {
		opacity: 0;
	}
</style>